import '@accessible360/accessible-slick';

export const PXReviews = (function ($) {
	'use strict';

	let $sliders;

	function init() {
		$sliders = $('.pxblock--reviews .reviews');

		$sliders.each(function () {
			if($(this).find('.review').length > 1){
				initSlider($(this));
			}
		});

		events();
	}

	function initSlider($slider) {
		$slider.slick({
			arrows: true,
			autoplay: true,
			autoplaySpeed: 7000,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			pauseOnHover: false,
			prevArrow: "<button type='button' class='slick-btn slick-btn--prev' aria-label='Previous Arrow'>Previous Arrow</button>",
			nextArrow: "<button type='button' class='slick-btn slick-btn--next' aria-label='Next Arrow'>Next  Arrow</button>",
		});
	}

	function events() {}

	return {
		init: init,
	};
})(jQuery);
